export default "__VITE_ASSET__BETQ$rQg__"